import React from "react";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { ProductCheckboxList } from "components/ProductCheckboxList";
import { routes } from "utilities/routing/generatedRoutes";
import SubLabel from "components/Atoms/Sublabel";
import { getInvoiceV1FormSections } from "invoice/getInvoiceV1FormSections";
import { useDocumentV1Form } from "documentV1/hooks";
import { isNullOrEmptyString } from "shared/utils";

interface Props {
  viewModel: server.viewmodel.InvoiceV1MakeCreditFrontModel;
}

export const MakeCreditEditSection = (props: Props) => {
  const { viewModel } = props;
  const { invoice } = viewModel;

  const hook = useDocumentV1Form({
    documentType: "invoice",
    initialAddressee: invoice.company,
    initialOwner: invoice.owner,
    initialCostCenter: invoice.costCenter,
    initialConcerning: [RESX.Invoice.CreditForInvoiceNumber.replace("{0}", invoice.documentNumber), invoice.concerning].filter(c => !isNullOrEmptyString(c)).join("\n\n"),
  });

  const [balanceImmediately, setBalanceImmediately] = React.useState<boolean>(false);
  const [selectedProducts, setSelectedProducts] = React.useState<number[]>(viewModel.products.map(p => p.productId));

  const submit = async () => {
    return window.CoreApi.Invoice.MakeCredit({
      invoiceId: invoice.invoiceId,
      balanceImmediately: balanceImmediately,
      dueInDays: hook.dueInDays,
      invoiceDate: hook.sendDate.toDate(),
      ownerUserId: hook.owner.userId,
      concerning: hook.concerning,
      selectedProductIds: selectedProducts,
    } satisfies Required<server.dto.MakeCreditInvoiceV1Instruction>);
  };

  const invoiceNewSections = getInvoiceV1FormSections(hook, {
    title: RESX.Invoice.MakeCredit,
    displayDocumentNumber: {
      number: invoice.documentNumber,
      locked: invoice.locked
    },
    displayProforma: false,
    readOnlyAddressee: true,
    displayBookkeeping: false,
    displayContact: false,

  });

  const noProductsSelected = selectedProducts.length === 0;
  const invoiceSettled = viewModel.invoice.lifeCycle === "completed"

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={(itemId) => routes.invoiceV1_Detail(itemId).absolute}
    sections={[
      invoiceNewSections,
      {
        key: "products",
        type: "regular",
        hidden: viewModel.products.length === 0,
        title: RESX.Product.Products,
        fields: [{
          key: "products",
          label: RESX.Product.Products,
          renderEditNew: () => (
            <ProductCheckboxList
              products={viewModel.products}
              selectedProducts={selectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
          )
        }]
      }, {
        key: "balanceImmediately",
        type: "regular",
        title: RESX.Financial.BalanceImmediately,
        hidden: noProductsSelected || invoiceSettled || !viewModel.canModifyPayments,
        fields: [{
          key: "balanceImmediately",
          label: RESX.Payment.Payments,
          renderEditNew: () => (
            <div className="main-section-template-fields-padding" style={{ paddingLeft: 0 }}>
              <Checkbox
                label={<div>
                  <div>{RESX.Financial.BalanceImmediately}</div>
                  <SubLabel small>{RESX.Invoice.BalanceImmediatelyHelpText}</SubLabel>
                </div>}
                checked={balanceImmediately}
                onChange={(_, checked) => setBalanceImmediately(checked)}
              />
            </div>
          )
        }]
      }]} />
};

export default MakeCreditEditSection;

